import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { replaceStringWithHighlight } from '../../../infrastructure/utils/common.utils';
import './text.scss';

interface IProps {
    message: string;
    className?: string;
    id?: string;
    description?: string;
    tag?: keyof JSX.IntrinsicElements;
    withHighlight?: boolean;
    withEllipsis?: boolean;
    highlightValue?: string;
    values?: object;
    onClick?: (e: React.MouseEvent) => void;
    onDoubleClick?: () => void;
    withoutTitle?: boolean;
    colSpan?: number;
    textTitle?: string;
    setAsHtml?: boolean;
    escapeHtml?: boolean;
}

const Text = (props: IProps) => {
    const {
        message,
        className,
        id,
        description = 'Text',
        tag: Wrapper = 'span',
        withHighlight = false,
        withEllipsis = false,
        withoutTitle = false,
        highlightValue,
        textTitle,
        values = {},
        setAsHtml,
        escapeHtml = false,
        ...otherProps
    } = props;

    const intl = useIntl();

    const text = id ? intl.formatMessage(
        {
            id: id,
            defaultMessage: message,
            description: description
        },
        {
            ...values
        }
    ) : message;

    const escapeHTML = (str: string): string => {
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };

    const processedText = escapeHtml ? escapeHTML(text) : text;

    const tempHtml = document.createElement('div');
    tempHtml.innerHTML = processedText || '';
    const dangerouslyText = tempHtml.textContent || tempHtml.innerText || '';

    const elementTitle = withEllipsis && !withoutTitle ? (textTitle ? textTitle : dangerouslyText) : undefined;
    const textAsHtml = setAsHtml ? {
        __html: processedText
    } : null;

    return (
        <Wrapper
            title={elementTitle}
            className={classnames({ 'overflow-ellipsis': withEllipsis }, className)}
            dangerouslySetInnerHTML={textAsHtml}
            {...otherProps}
        >
            { setAsHtml ? null : withHighlight ? replaceStringWithHighlight(dangerouslyText, highlightValue) : dangerouslyText }
        </Wrapper>
    );
};

export default Text;
